export default __webpack_public_path__ + "static/rapport-7dec130d9289e813b7b8fe0b511a1a2e.png";